"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FullBar = _interopRequireDefault(require("../baseComponents/FullBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TaskBar = /*#__PURE__*/function (_Component) {
  _inherits(TaskBar, _Component);

  var _super = _createSuper(TaskBar);

  function TaskBar(props) {
    var _this;

    _classCallCheck(this, TaskBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "taskBarDefinition", null);

    _this.show = _this.show.bind(_assertThisInitialized(_this));
    _this.hide = _this.hide.bind(_assertThisInitialized(_this));
    _this.setNewState = _this.setNewState.bind(_assertThisInitialized(_this));
    _this.setStateFromProps = _this.setStateFromProps.bind(_assertThisInitialized(_this));
    _this.isShowing = _this.isShowing.bind(_assertThisInitialized(_this));
    _this.taskBarDefinition = _this.setStateFromProps(props);
    _this.state = _this.setStateFromProps(props);
    return _this;
  }

  _createClass(TaskBar, [{
    key: "show",
    value: function show() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          display: true
        });
      }, this.state.showAfter);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this3 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      setTimeout(function () {
        _this3.setState({
          display: false
        });

        callback();
      }, this.state.hideAfter);
    }
  }, {
    key: "setNewState",
    value: function setNewState(state) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.setState(this.setStateFromProps(state), function () {
        callback();
      });
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this.state.display;
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps(props) {
      var nextProps = props || {};
      var definition = this.taskBarDefinition || {};
      return {
        display: this.state ? this.state.display : false,
        type: nextProps.type || definition.type || "default",
        position: nextProps.position || definition.position || "bottom",
        className: nextProps.className || definition.className || "",
        style: nextProps.style || definition.style || null,
        tasks: nextProps.tasks || definition.tasks || null,
        hideAfter: nextProps.hideAfter || definition.hideAfter || 0,
        showAfter: nextProps.showAfter || definition.showAfter || 0
      };
    }
  }, {
    key: "render",
    value: function render() {
      var classes = (0, _classnames["default"])("taskBar-component", this.state.className, this.state.type, this.state.position, {
        "show": this.state.display
      });
      var tasks = this.state.tasks;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "taskBar-component",
        className: classes,
        style: this.state.style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "taskBarContentContainer"
      }, Array.isArray(tasks) ? tasks.map(function (task, index) {
        var classes = (0, _classnames["default"])("task", task.className, {
          "manualContent": task.manualContent
        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: classes
        }, task.content);
      }) : tasks));
    }
  }]);

  return TaskBar;
}(_react.Component);

;
TaskBar.propTypes = {
  type: _propTypes["default"].oneOf(["default"]),
  position: _propTypes["default"].oneOf(["bottom", "top"]),
  tasks: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({
    manualContent: _propTypes["default"].bool,
    content: _propTypes["default"].any,
    className: _propTypes["default"].string
  })), _propTypes["default"].object]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
TaskBar.defaultProps = {
  type: "default",
  position: "bottom",
  task: []
};
var _default = TaskBar;
exports["default"] = _default;